<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>{{ tool.id ? 'Edit' : 'Create' }} Tool</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<form #form="ngForm" (ngSubmit)="onSubmit(form, !tool.id)">

  <hr class="m-0 p-0">

  <mat-dialog-content class="px-3 py-4">

    <div class="row">
      <div class="col-12 col-md-6">
        <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
          <mat-label>Tool</mat-label>
          <input
            matInput
            placeholder="Tool"
            [(ngModel)]="tool.title"
            name="title"
            type="text"
            required
            #title />
          <mat-hint>Please enter a Tool title.</mat-hint>
        </mat-form-field>
      </div>
      <div class="col-12 col-md-6">
        <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
          <mat-label>Industry</mat-label>
          <mat-select [(ngModel)]="tool.industry_id" name="industry" #industry>
            <mat-option [value]="0">All</mat-option>
            <mat-option *ngFor="let industry of industries" [value]="industry.id">{{ industry.name }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
      <mat-label>Description</mat-label>
      <textarea
        rows="4"
        matInput
        placeholder="Description"
        [(ngModel)]="tool.description"
        name="description"
        #description>
      </textarea>
      <mat-hint>Please enter a short description for the tool.</mat-hint>
    </mat-form-field>

    <div class="row">
      <div class="col-12 col-md-6">
        <app-datetime-picker
          [selectedDateTime]="expiresAtDateTime"
          [pickerName]="'expiresAtDateTime'"
          [label]="'Select the tool\'s expiry date.'"
          [hint]="'Use the calendar icon to select the date and time.'"
          [selectTooltip]="'Select the date and time.'"
          [removeTooltip]="'Clear the date and time.'"
          [classes]="'full-width mb-4'"
          (pickerDetailsOutput)="getOutputDateTimeDetails($event)"></app-datetime-picker>
      </div>
      <div class="col-12 col-md-6">
        <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
          <mat-label>Maintenance & Safety Checks List</mat-label>
          <mat-select [(ngModel)]="tool.maintenance_safety_checks" name="maintenance_safety_check" multiple>
            <ng-container *ngFor="let maintenance_safety_check of utils.getToolsMaintenanceAndSafetyChecksList(); let i = index;">
              <mat-option [value]="maintenance_safety_check">{{ maintenance_safety_check }}</mat-option>
              <mat-divider *ngIf="i == 9"></mat-divider>
            </ng-container>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

  </mat-dialog-content>

  <hr class="m-0 p-0">

  <mat-dialog-actions class="p-3">

    <button
      mat-raised-button
      [disabled]="!form.valid || inProgress"
      color="primary"
      type="submit"
      class="my-2 ml-1 mr-2"
      id="save">
      <mat-icon>save</mat-icon>
      Save
    </button>

    <app-file-browse-button
      (selectedFiles)="onSelectFiles($event)"
      (afterDialogClosedEvent)="onSubmit(form, false)"
      parentObjectType="tool"
      [parentObjectId]="tool.id"
      [filesCount]="tool?.files?.length">
    </app-file-browse-button>

    <button
      *ngIf="canDelete"
      type="button"
      color="warn"
      class="dialog-remove-button my-2 ml-auto mr-1"
      mat-icon-button
      [disabled]="!tool.id"
      (click)="onDelete()"
      matTooltip="Archive this Tool">
      <mat-icon>archive</mat-icon>
    </button>

  </mat-dialog-actions>

</form>
